<template>
  <card :title="title" id="user-details" v-if="canEdit || canDelete" v-cloak>
    <span class="action_buttons" v-if="false">
      <img src="~@/assets/images/desktop/icons/controls/plus.svg" class="icon-svg" :title="$t('create_user')" @click="newUser()"/>
    </span>
    <div class="col-lg-8">
      <div class="row">
        <div class="col-lg-8 pb-3" v-if="data && data.uuid">
          <h5>{{$t("assign_departments")}}</h5>
          <DepartmentRoleGrid
              v-if="!is_company_admin"
              :user="data"
              :departments="userDepartments"
              :roles="roles"
              @onChange="onDepartmentsChanged"
          />
          <p  class="text-danger" v-else>{{$t("user_marked_as_company_admin")}}</p>
        </div>
        <div class="col-lg-8 pb-3 text-danger" v-else>
          {{ $t('company.departments.unable_to_assign') }}
        </div>
      </div>
      <div class="row">
        <div class="form-group col-sm-12 col-lg-8">
          <label class="control-label">{{ $t('common.first_name') }}</label>
          <input type="text" v-model="data.first_name"
                 :class="{ 'field-error' : this.$v.data.first_name.$error }"
                 :placeholder='$t("common.first_name")'
                 class="form-control"/>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-lg-8">
          <label class="control-label">{{ $t('common.last_name') }}</label>
          <input type="text" v-model="data.last_name"
                 :class="{ 'field-error' : this.$v.data.last_name.$error }"
                 :placeholder='$t("common.last_name")'
                 class="form-control"/>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-sm-12 col-lg-8">
          <label class="control-label">{{$t("common.e_mail")}}</label>
          <input type="text" v-model="data.email"
                 :class="{ 'field-error' : this.$v.data.email.$error }"
                 :placeholder='$t("common.e_mail")'
                 class="form-control"/>
        </div>
      </div>
      <div class="row" v-if="!data.uuid">
        <div class="form-group col-sm-12 col-lg-4">
          <label class="control-label">{{ $t('common.password') }}</label>
          <input type="password" v-model="data.password"
                 :class="{ 'field-error' : this.$v.data.password.$error }"
                 :placeholder='$t("common.password")'
                 class="form-control"/>
        </div>
        <div class="form-group col-sm-12 col-lg-4">
          <label class="control-label">{{ $t('confirm_password') }}</label>
          <input type="password" v-model="data.confirm_password"
                 :class="{ 'field-error' : this.$v.data.confirm_password.$error }"
                 :placeholder='$t("confirm_password")'
                 class="form-control"/>
        </div>
      </div>
      <div class="row" v-else>
        <div class="form-group col-sm-12 col-lg-8" v-if="canEdit">
          <a v-on:click.stop.prevent="showPasswordDialog(data)"
             v-if="isCompanyAdmin || (data.uuid === user && user.uuid)"
             class="c-pointer additional">{{ $t('common.click_here_to_change_password') }}</a>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-sm-12 col-lg-8">
          <label class="control-label">{{ $t('common.phone') }}</label>
          <input type="text" v-model="data.phone_number"
          :placeholder='$t("common.phone")'
                 class="form-control"/>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-lg-4">
          <b-form-checkbox switch size="lg"
                           v-model="is_company_admin"
                           :disabled="!data.uuid"
                           @change="onCompanyAdminChanged">Company admin</b-form-checkbox>
        </div>
        <div class="form-group col-lg-6">
          <b-form-checkbox switch size="lg"
                           v-model="api_access"
                           @change="onApiAccessChanged"
                           :disabled="!data.uuid"
          >Smagria App access</b-form-checkbox>
        </div>
      </div>

    </div>
    <div class="col-lg-12 action-buttons pt-4">
      <div class="row form-group">
        <div class="col-lg-8 text-center text-lg-left">
          <div class="row">
            <div class="col-lg-6">
              <button class="btn btn-md btn-secondary btn-secondary" @click="gotoList">{{ $t('common.back_to_user_list') }}</button>
            </div>
            <div class="col-lg-3" v-if="canEdit">
              <button class="btn btn-md btn-primary" @click="save">{{ $t('common.save') }}</button>
            </div>
            <div class="col-lg-3" v-if="data.uuid && canDelete">
              <button class="btn btn-md btn-danger" @click="confirmDelete">{{ $t('common.delete') }}</button>
            </div>
            <change-password-dialog :show="showPasswordModal" @close="showPasswordModal = false"
                                    :data="passwordModalData"
                                    @onPasswordChanged="onPasswordChanged"
            ></change-password-dialog>
          </div>
        </div>
      </div>
    </div>
  </card>
  <div v-else>
    <forbidden></forbidden>
  </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import * as type from '../../store/mutation-types'
    import {successMessage, errorMessage, errorMessageList} from '~/helpers/common'
    import required from "vuelidate/src/validators/required";
    import requiredIf from "vuelidate/src/validators/requiredIf";
    import ChangePasswordDialog from "./partials/ChangePasswordDialog";
    import { permissions, permissionTypes, canEdit, canDelete} from "~/helpers/Permissions";
    import Forbidden from "~/pages/errors/Forbidden.vue";
    import DepartmentRoleGrid from "@/pages/users/partials/UserRoleSelector.vue";

    export default {
      name: 'userDetails',
      middleware: 'check-company-admin',
      data() {
        return {
          initialUser: {
            uuid: null,
            unit_uuid: '',
          },
          imageData: {},
          image_removed: false,
          showModal: false,
          modalData: {},
          showPasswordModal: false,
          passwordModalData: {},
          is_company_admin: false,
          department_list: this.departments ? this.departments : [],
          api_access: false,
        }
      },
      components: {
        DepartmentRoleGrid,
        Forbidden,
        ChangePasswordDialog,
      },
      computed: {
        config() {
          return {
            permission: permissions.USER_MANAGEMENT,
            permission_type: permissionTypes.module,
          };
        },
        ...mapGetters({
          user: 'auth/user',
          userData: 'user/userData',
          isCompanyAdmin: 'auth/isCompanyAdmin',
          roles: 'roles/roles',
          departments: 'company/departments',
          domain: 'auth/domain'
        }),
        data: {
          get: function () {
            return this.userData ? this.userData : this.initialUser;
          },
          set: function (newVal) {
            return newVal;
          }
        },
        server() {
          return window.location.host;
        },
        title() {
          return this.data.uuid ? this.$t('edit_user') : this.$t('create_user');
        },
        canEdit() {
          return canEdit(this);
        },
        canDelete() {
          return canDelete(this);
        },
        userDepartments() {
          this.department_list.forEach((item) => {
            const role = this.getDepartmentRole(item);

            if (role && role.role_uuid) {
              const updatedDepartment = Object.assign({}, item);
              updatedDepartment.role_uuid = role.role_uuid;
              this.department_list.splice(
                  this.department_list.indexOf(
                      item
                  ),1, updatedDepartment
              )
            }
          });

          return this.department_list;
        }
      },
      methods: {
        ...mapActions({
          getUser: 'user/getUser',
          createUser: 'user/createUser',
          updateUser: 'user/updateUser',
          deleteUser: 'user/deleteUser',
          changePassword: 'user/changePassword',
          getRoles: 'roles/getRoles',
          getDepartments: 'department/getDepartments'
        }),
        getDepartmentRole(department) {
          const foundDep = Object.assign([], this.data.units).find(d => d.uuid === department.uuid);

          if (foundDep && foundDep.role && foundDep.role.role_uuid) {
            return foundDep.role;
          }

          return null;
        },
        getUserData() {
          let vm = this;

          if (this.$route.params.uuid && this.$route.params.uuid !== 'add') {
            this.$store.dispatch('user/getUser', {
              uuid: this.$route.params.uuid
            }).then((response) => {

              if (response === null || (response && !response.is_active && response.deleted_at)) {
                errorMessage(vm, vm.$t('user_not_available'));
                setTimeout(function () {
                  vm.$router.push({
                    path: '/users',
                  });
                }, 2000);
              } else {
                //loaded
                vm.getDepartments({
                  user_filter_uuid: response.uuid
                });
              }
            }).catch((e) => {
              errorMessage(vm, vm.$t('user_not_found'));
              setTimeout(function () {
                vm.$router.push({
                  path: '/users',
                });
              }, 2000);
            });
          } else {
            this.$store.commit("user/" + type.SET_USER_DATA, this.initialUser);
          }
        },
        confirmDelete() {
          let vm = this;

          this.$dialog.confirm('Do you really want to delete this "' + this.data.name + '" user?', {})
              .then((dialog) => {
                vm.deleteUser({
                  uuid: this.data.uuid,
                }).then((response) => {
                  dialog.close();
                  successMessage(vm, response.message);
                  setTimeout(function () {
                    vm.$router.push({
                      path: '/users',
                    });
                  }, 2000);
                }).catch((response) => {
                  dialog.close();
                  errorMessage(vm, response.message);
                });
              });
        },
        save() {
          let vm = this;
          this.$v.data.$touch();
          if (!this.$v.data.$invalid) {

            if (this.data.image && this.data.image.uuid) {
              this.data.image = null;
            }

            if (this.data.password !== this.data.confirm_password) {
              errorMessage(vm, vm.$t('common.the_two_passwords_do_not_match'));
              return;
            }

            if (this.data.is_company_admin === 1) {
              this.data.units = [];
            }

            if (this.data.uuid) {
              this.updateUser(this.data).then((response) => {
                successMessage(vm, response.message);
              }).catch((e) => {
                errorMessageList(vm, e.errors);
              });
            } else {
              this.createUser(this.data).then((response) => {
                successMessage(vm, response.message);
                vm.$router.push({
                  path: '/users/' + response.data.uuid,
                });
              }).catch((e) => {
                errorMessageList(this, e.errors);
              });
            }

          } else {
            errorMessage(this, this.$t('fill_out_error'));
          }
        },
        newUser() {
          this.$store.commit('user/' + type.SET_USER_DATA, this.initialUser);

          try {
            this.$router.push({
              path: 'add'
            }).catch((e) => {
            });
          } catch (e) {
            window.location.href = '/users/add';
          }
        },
        gotoList() {
          this.$router.push({
            path: '/users',
          })
        },
        showPasswordDialog(item) {
          this.passwordModalData = item;
          this.showPasswordModal = true;
        },
        onPasswordChanged(data) {
          let vm = this;
          this.changePassword(data).then((response) => {
            successMessage(vm, response.message);
            vm.data.password = null;
            vm.data.confirm_password = null;
          })
        },
        onCompanyAdminChanged(val) {
          this.data.is_company_admin = val ? 1 : 0;
        },

        onApiAccessChanged(val) {
          this.data.api_access = val ? 1 : 0;
        },
        onDepartmentsChanged(updatedDepartments) {
          console.log('Updated Departments:', updatedDepartments);
          this.data.units = updatedDepartments;
          console.log('current user', this.data);
        },
      },
      mounted() {
        this.getRoles({});
        this.getUserData();
      },
      watch: {
        userData: {
          handler: function (newVal) {
            this.data = newVal;
            this.is_company_admin = (newVal && newVal.is_company_admin === 1);
            this.api_access = (newVal && newVal.api_access === 1);
          },
          deep: true,
        },
          departments: {
            handler: function (newVal) {
              this.department_list = newVal;
            },
            deep: true,
            immediate: true,
          }
      },
        validations() {
          let vm = this;
          return {
            data: {
              first_name: {
                required,
              },
              last_name: {
                required,
              },
              email: {
                required,
              },
              password: {
                required: requiredIf(function (pw) {
                  return vm.data.uuid === null;
                })
              },
              confirm_password: {
                required: requiredIf(function (pw) {
                  return vm.data.uuid === null;
                }),
              }

            },
          }
        },
      }
</script>
